<template>
  <div>
    <h4 class="workplatform-title m-t-10 m-b-10">基本信息</h4>
    <Row class="p-b-5">
      <i-col span="8">
        <label class="title text-title-65">资源编号</label>{{ meterBean.deviceCode }}
      </i-col>
      <i-col span="8">
        <span class="title text-title-65">电表编号</span>{{ meterBean.meterCode }}
      </i-col>
      <i-col span="8">
        <span class="title text-title-65">所属线路</span>{{ meterBean.assetName }}
      </i-col>
    </Row>

    <Row class="p-b-5">
      <i-col span="8">
        <span class="title text-title-65">所属站点</span>{{ meterBean.stationName }}
      </i-col>
    </Row>

    <h4 class="workplatform-title m-t-10 m-b-10">数据记录</h4>
    <Table size="small" stripe :data="tableData" :loading="tableLoading" :columns="tableColumns"></Table>
    <div class="paging_style">
      <Page size="small" :total="totalRow" :page-size="query.size" show-total show-elevator
        :current="query.current" @on-change="handleChangePage"></Page>
    </div>
  </div>
</template>

<script>
import { formatDebtStatus } from '@/utils/tagStatus'
import { pageElectricMeterRecord } from '@/api/invest/electricMeterRecord'

export default {
  props: {},
  data () {
    return {
      query: {
        current: 1,
        size: 15,
        meterId: null,
        assetId: null,
        keyWord: null,
        stationId: null,
        contractId: null
      },

      tableLoading: false,
      totalRow: 0,
      tableData: [],
      tableColumns: [
        { title: '最近抄表时间', key: 'readDate' },
        { title: '本期读表数', key: 'currentValue' },
        { title: '本期用电量(kwh)', key: 'electricityConsume' },
        { title: '归属合同', key: 'contractName' },
        { title: '单位(客户)', key: 'advertiserName' },
        { title: '线损', key: 'lineLost' },
        { title: '电费单价', key: 'unitPrice' },
        { title: '本期电费合价(元)', key: 'chargeAmount' },
        { title: '计价月份', key: 'chargeMonth' },
        {
          title: '账单状态',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return formatDebtStatus(
              h,
              params.row.status,
              params.row.statusName
            )
          }
        }
      ]
    }
  },
  mounted () {},
  created () {
    this.initPageData()
  },
  methods: {
    initPageData () {
      this.query.meterId = this.meterBean.meterId
      this.getBasicData()
    },
    getBasicData () {
      this.tableLoading = true
      pageElectricMeterRecord(this.query).then(res => {
        this.tableData = res.records
        this.totalRow = res.total
        this.tableLoading = false
      })
    },
    handleChangePage (currentPage) {
      this.query.current = currentPage
      this.getBasicData()
    }
  },
  computed: {
    meterBean () {
      return this.$store.state.investmentElecBasic.meter || {}
    }
  }
}
</script>
